import { render, staticRenderFns } from "./ProjectTaskTemplateDetailEdit.vue?vue&type=template&id=350e8661"
import script from "./ProjectTaskTemplateDetailEdit.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTemplateDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports